// extracted by mini-css-extract-plugin
module.exports = {"gearboxStudents":"SubmitterList_gearboxStudents__2Ny4f","loading":"SubmitterList_loading__2_eEi","emptyData":"SubmitterList_emptyData__1Rc4s"};